module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('LayoutContainer', {
    attrs: {
      "columns": "30/70"
    }
  }, [_c('v-toolbar', {
    staticClass: "primary no-print",
    attrs: {
      "slot": "header",
      "dark": ""
    },
    slot: "header"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('v-icon', [_vm._v("home")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.pageTitle))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": "",
      "nudge-width": 200
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "dark": ""
          }
        }, on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', [_c('v-list-item-title', [_vm._v("Do Something")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "no-print",
    attrs: {
      "slot": "col1"
    },
    slot: "col1"
  }, [_c('AdvancedList', {
    attrs: {
      "items": _vm.templates,
      "data-ref": _vm.listRef
    },
    on: {
      "click": _vm.selectTemplate
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "col2"
    },
    slot: "col2"
  }, [(_vm.checklistKey) ? [_c('AdvancedPanel', {
    staticClass: "no-print",
    attrs: {
      "fields": _vm.templateDetailsPanel.fields,
      "record": _vm.templateDetails,
      "recordRef": _vm.listItemRef,
      "settings": _vm.templateDetailsPanel.settings
    },
    on: {
      "button": _vm.templateDetailsButton,
      "field-change": _vm.templateDetailsFieldChanged
    }
  }), _vm._v(" "), _c('ChecklistDetails', {
    ref: "templateDetails",
    attrs: {
      "checklistKey": _vm.checklistKey,
      "mode": "Template"
    }
  })] : [_c('NoRecordsPlaceholder', {
    attrs: {
      "message": "Select a Template"
    }
  })]], 2), _vm._v(" "), _c('template', {
    slot: "dialogs"
  }, [_c('AdvancedDialog', {
    attrs: {
      "record": _vm.addDocumentDialog.record,
      "settings": _vm.addDocumentDialog.settings,
      "fields": _vm.addDocumentDialog.fields
    },
    on: {
      "save": _vm.saveDocumentForCategory
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-620fe7b3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SupplierChecklist/ChecklistTemplates.vue
// module id = 2579
// module chunks = 1